import React from 'react';
import {createBrowserRouter} from 'react-router-dom';
import MainRoutes from './mainRoutes';
import RouteErrorFallback from './RouteErrorFallback';

export const router = createBrowserRouter(
    [{Component: MainRoutes, errorElement: <RouteErrorFallback />, path: '*'}]
);
